import { render, staticRenderFns } from "./AgentCalculationList.vue?vue&type=template&id=72d0f00d&scoped=true"
import script from "./AgentCalculationList.vue?vue&type=script&lang=js"
export * from "./AgentCalculationList.vue?vue&type=script&lang=js"
import style0 from "./AgentCalculationList.vue?vue&type=style&index=0&id=72d0f00d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0f00d",
  null
  
)

export default component.exports